var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"mt-0 px-0",attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" Приложение недоступно, повторите попытку позже ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }